define('modules/editor/views/property_boxes/background',['require','exports','module','./base','../../services/image_upload/index','ldsh!../../templates/property_boxes/background'],function(require, exports, module){
  "use strict";
  var BasePropertyBox = require("./base"),
      ImageService = require("../../services/image_upload/index");

  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/background"),
    myEvents: {
      "change .js-range": "onRangeChange",
      "click .js-image": "getImage",
      "click .js-remove-image": "removeImage",
      "change .js-type": "onBackgroundTypeChange"
    },
    initialize: function(){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,arguments);
    },
    onRangeChange: function(e){
      //console.log($(e.currentTarget).val());
      var value = $(e.currentTarget).val();
      this._updateRangeValue(value);
      this._getPropertyValues();
    },
    getImage: function(e){
      e.preventDefault();
      ImageService.loadImage(this.model.get("imageUrl"), _.bind(this.onImageLoaded, this));
    },
    removeImage: function(e){
      e.preventDefault();
      this.model.set("imageUrl", null);
    },
    onImageLoaded: function(result){
      this.model.set("imageUrl", result.url);
    },
    onRender: function(){
      this._updateRangeValue(this.model.get("opacity"));
      this._updateType(this.model.get("type"));
      this.$el.i18n();
    },
    onBackgroundTypeChange: function(e){
      this._updateType($(e.currentTarget).val());
    },
    updateUI: function(){
      this._updateRangeValue(this.model.get("opacity"));
      this._updateType(this.model.get("type"));
    },
    _updateRangeValue: function(value){
      this.$(".js-range-value").html(value);
    },
    _updateType: function(type){
      this.$(".js-image-panel").toggle(type === "solid");
      this.$(".js-gradient-panel").toggle(type === "gradient");
    }
  });
});
